<template>
  <div v-if="!isSymposium" class="wrap-banner">
    <Logo />
    <Carousel />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Logo from './Logo'
import Carousel from './Carousel'

export default {
  components: {
    Logo,
    Carousel
  },

  computed: {
    ...mapState({
      isSymposium: state => state.symposium.isSymposium
    }),
  },
}
</script>
